import React from 'react'
import { Form } from 'antd'
import PropTypes from 'prop-types'
import GroupsLineItemList from './Proposals/GroupsLineItemList'
import { getWorkareaIdsFromSelectedLineItems } from '../helpers/proposal'
import ApprovalAndPayment from './ApprovalAndPayment'
import Payment from './Payment'
import ConfirmAndSign from './ConfirmAndSign'

class GroupsEstimateForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      lineItems: props.defaultEstimate.lineItems,
    }
  }

  onSubmit = (approvedBy) => {
    const data = {
      approvedByName: approvedBy,
      workareas: getWorkareaIdsFromSelectedLineItems(this.state.lineItems)
    }
    this.props.onSubmit(data)
  }

  onSelectedChange = (id, checked) => {
    this.setState({ lineItems: this.state.lineItems.map(x => x.id === id ? { ...x, isSelected: checked } : x) })
  }

  render = () => {
    const { termsAndConditions, showPricingType, links } = this.props.defaultEstimate
    
    return <Form>

      <GroupsLineItemList items={this.state.lineItems}
        showPricingType={showPricingType}
        onSelectedChange={this.onSelectedChange}
      />

      <p className="text-small">Terms and Conditions:</p>
      <p className={['description', ...(termsAndConditions?.includes('ql-indent') ? ['quill-rich-text'] : [])]}
        dangerouslySetInnerHTML={{
          __html: termsAndConditions
        }}
      />
      <br />
      <div>
        {links.map((link, i) =>
          <p key={i}><a target="_blank" rel="noopener noreferrer" href={link.url}>{link.displayText}</a></p>)}
      </div>
      <div className="clearfix">
        {(this.props.defaultEstimate.paymentScheduleOptions.useProgressBasedOnly) && <ApprovalAndPayment
          lineItems={this.state.lineItems}
          paymentSchedule={this.props.defaultEstimate.paymentScheduleOptions.quotedAndTimeAndMaterials.progressBased}
          showPdfLink={this.props.defaultEstimate.showPdfLink}
          isPreview={this.props.preview}
          onSubmit={(approvedBy) => this.onSubmit(approvedBy)}
          isSubmitting={this.props.isSubmitting}
        />}

        {!this.props.defaultEstimate.paymentScheduleOptions.useProgressBasedOnly && <>
          <Payment lineItems={this.state.lineItems} paymentScheduleOptions={this.props.defaultEstimate.paymentScheduleOptions} />
          <ConfirmAndSign
            showPdfLink={this.props.defaultEstimate.showPdfLink}
            isPreview={this.props.preview}
            onSubmit={(approvedBy) => this.onSubmit(approvedBy)}
            isSubmitting={this.props.isSubmitting}
          />
        </>}
      </div>
    </Form>
  }
}

GroupsEstimateForm.propTypes = {
  defaultEstimate: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired
}
export default GroupsEstimateForm
